import { render, staticRenderFns } from "./detail-guanlian.vue?vue&type=template&id=fc88b646&"
import script from "./detail-guanlian.vue?vue&type=script&lang=js&"
export * from "./detail-guanlian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports